export const APP_ROUTES = {
    LOGIN: '/',
    RESET: '/reset',
    SIGNUP: '/signup',
    NEW_PASSWORD: '/newpassword',
    DASHBOARD: '/r'
};

export const LAYOUT_ROUTES = {
    OVERVIEW: '/r/overview',
    CARDS: '/r/cards',
    TRANSACTIONS: '/r/transactions',
    REWARDS: '/r/rewards',
    PROFILE: '/r/profile',
    USERS: '/r/users',
    BUSINESSES: '/r/businesses',
    CUSTOMERS: '/r/customers'
};
